import React, { useState, useEffect } from 'react';
import { Palmtree, User, ArrowRight, X, Calendar } from 'lucide-react';
import axiosInstance from '../../utils/axiosConfig';
import { useNavigate } from 'react-router-dom';
import { formatFecha } from '../gh';

// Lo que le toca al que mira: el jefe aprueba; GH registra (o aprueba y registra si va directo a GH)
const accionDe = (p) => {
    if (p.estado === 'aprobada') return 'Registrar';
    return p.aprueba_gh ? 'Aprobar y registrar' : 'Aprobar';
};

const VacacionesPendientesWidget = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [dismissed, setDismissed] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const today = new Date().toDateString();
        const key = `widget_dismiss_vacaciones_${today}`;
        if (localStorage.getItem(key)) setDismissed(true);
    }, []);

    useEffect(() => {
        fetchPendientes();
    }, []);

    const fetchPendientes = async () => {
        try {
            const res = await axiosInstance.get('/api/vacaciones/pendientes');
            if (res.data.total > 0) setData(res.data);
        } catch (err) {
            console.error('Error cargando vacaciones pendientes:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleDismiss = () => {
        if (window.confirm('¿Deseas ocultar este widget por hoy?')) {
            const today = new Date().toDateString();
            localStorage.setItem(`widget_dismiss_vacaciones_${today}`, 'true');
            setDismissed(true);
        }
    };

    if (loading || !data || dismissed) return null;

    return (
        <section className="relative rounded-2xl overflow-hidden border border-emerald-200 shadow-sm group">
            <button
                onClick={handleDismiss}
                className="absolute top-3 right-3 z-20 w-6 h-6 rounded-full bg-white/80 backdrop-blur-sm text-gray-400 hover:text-gray-600 hover:bg-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all shadow-sm"
                title="Ocultar por hoy"
            >
                <X size={14} />
            </button>

            <div className="bg-gradient-to-r from-emerald-500 to-teal-600 px-5 py-4 text-white">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center">
                        <Palmtree size={20} />
                    </div>
                    <div>
                        <h3 className="font-bold text-lg">Vacaciones por revisar</h3>
                        <p className="text-white/80 text-sm">
                            {data.total} solicitud{data.total !== 1 ? 'es esperan' : ' espera'} por ti
                        </p>
                    </div>
                </div>
            </div>

            <div className="bg-emerald-50 p-5 space-y-3">
                {data.pendientes.slice(0, 3).map(p => (
                    <div key={p.id} className="bg-white rounded-xl p-3 border border-gray-100 shadow-sm">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2 min-w-0">
                                <User size={14} className="text-gray-400 flex-shrink-0" />
                                <span className="text-sm font-medium text-gray-900 truncate">{p.empleado_nombre}</span>
                            </div>
                            <span className="text-xs text-emerald-600 bg-emerald-50 px-2 py-0.5 rounded-full font-medium flex-shrink-0 ml-2">
                                {accionDe(p)}
                            </span>
                        </div>
                        {p.fecha_inicio && (
                            <div className="flex items-center gap-2 mt-1.5 text-xs text-gray-500">
                                <Calendar size={12} />
                                <span>{formatFecha(p.fecha_inicio)} al {formatFecha(p.fecha_fin)}, {p.dias_habiles} días hábiles</span>
                            </div>
                        )}
                    </div>
                ))}

                {data.total > 3 && (
                    <p className="text-xs text-emerald-600 text-center font-medium">
                        y {data.total - 3} más...
                    </p>
                )}

                <button
                    onClick={() => navigate('/solicitud-vacaciones')}
                    className="w-full py-3 rounded-xl bg-gray-900 text-white font-medium flex items-center justify-center gap-2 hover:bg-gray-800 transition-colors"
                >
                    Revisar solicitudes
                    <ArrowRight size={16} />
                </button>
            </div>
        </section>
    );
};

export default VacacionesPendientesWidget;
